import { Signal } from './Signal';
import { CancelToken, CancelSource } from './CancelError';

/**
 * Creates a promise which waits for the given timeout to elapse.
 * @public
 */
export function wait(time: number): Promise<void> {
    const {
        resolve,
        promise
    } = new Signal<void>();

    window.setTimeout(() => resolve(), time);

    return promise;
}

/**
 * Creates a cancel token source which will be automatically canceled on a timeout, unless first disposed.
 * Alternatively, if a parent cancel token is provided, the source and timeout will be canceled if the parent
 * is canceled.
 * @beta
 */
export function createTimeoutCancelSource(timeout: number, cancelToken?: CancelToken): Pick<CancelSource, 'dispose' | 'token'> {
    let timeoutId: number | undefined;

    const cancelSource = new CancelSource();

    const dispose = () => {
        cancelSource.dispose();

        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }
    };

    if (cancelToken) {
        cancelToken.subscribe(() => {
            cancelSource.cancel();

            dispose();
        });
    }

    timeoutId = window.setTimeout(() => {
        cancelSource.cancel();
    }, timeout);

    return {
        dispose,
        token: cancelSource.token
    };
}
